export interface ICompanyExportTableHeaders {
    name: string;
    street: string;
    additionToAddress: string;
    zip: string;
    city: string;
    country: string;
    legalform: string;
    email: string;
    phone: string;
    UID: string;
    taxDomicile: string;
    assignee: string;
    clerk: string;
    GICSCode: string;
    firstName: string;
    lastName: string;
    workFlow: string;
}
